<div class="title">
  <div class="title-text">
    <div class="title-text-name">
      {{ productPackage().packageName }}
    </div>
    @if (productPackage().nmId) {
      <div class="title-text-marketplace">
        WB: {{ productPackage().nmId }}
      </div>
    }
    @if (productPackage().sku) {
      <div class="title-text-marketplace">
        OZON: {{ productPackage().sku }}
      </div>
    }
  </div>
  <div class="title-size">
    <div>
      {{ getSizeParams() }}
    </div>
    <div>
      {{ getSWightQuantityParams() }}
    </div>
  </div>
  @if (productPackage().history?.length) {
    <button
      mat-mini-fab
      class="title-btn"
      (click)="handleBtnClick($event, 'history')"
    >
      <mat-icon class="title-btn-icon">history</mat-icon>
    </button>
  }

  @if (!!productPackage().id && isEditModeActive()) {
    <button
      mat-mini-fab
      class="title-btn"
      (click)="handleBtnClick($event, 'delete')"
    >
      <mat-icon class="title-btn-icon">delete</mat-icon>
    </button>
  }
</div>
